import logo from '@/assets/logo.png';
import { EntityNotFound } from '@/components/entity-not-found';
import { Box, Container, Link, Paper, Stack } from '@mui/material';

const MARKETING_URL = 'https://www.hardfin.com/';
const PRIVACY_POLICY_URL = 'https://www.hardfin.com/legal/privacy-policy';
const TERMS_OF_SERVICE_URL = 'https://www.hardfin.com/legal/terms-of-service';

/**
 * Global 404 component for unmatched routes.
 * Uses EntityNotFound with home button instead of back button.
 * Wrapped in the same app frame structure as the login page.
 */
export function GlobalNotFound() {
  return (
    <Box
      display="grid"
      gridTemplateColumns="1fr"
      gridTemplateRows="1fr auto"
      alignItems="center"
      justifyContent="center"
      bgcolor="grey.50"
      width="100dvw"
      height="100dvh"
    >
      <Container component="main" maxWidth="sm">
        <Paper
          elevation={16}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Stack padding={4} minWidth="30rem" alignItems="center">
            <Link href={MARKETING_URL}>
              <img alt="logo" src={logo} height="40px" width="auto" />
            </Link>
            <EntityNotFound
              entityType="page"
              listPath="/"
              listLabel="Go home"
              showBackButton={false}
            />
          </Stack>
        </Paper>
      </Container>
      <Stack
        direction="row"
        marginLeft="auto"
        marginRight={{ xs: 'auto', sm: 2 }}
        marginBottom={2}
        spacing={1}
      >
        <Link
          rel="noopener"
          target="_blank"
          variant="caption"
          href={PRIVACY_POLICY_URL}
        >
          Privacy policy
        </Link>
        <Link
          rel="noopener"
          target="_blank"
          variant="caption"
          href={TERMS_OF_SERVICE_URL}
        >
          Terms of service
        </Link>
      </Stack>
    </Box>
  );
}
